// extracted by mini-css-extract-plugin
export default {"tableRenderer":"styles__tableRenderer___loA3_","instructional":"styles__instructional___vxeFC"};